import { render, staticRenderFns } from "./DashboardAI.vue?vue&type=template&id=d6ec4a02&scoped=true"
import script from "./DashboardAI.vue?vue&type=script&lang=js"
export * from "./DashboardAI.vue?vue&type=script&lang=js"
import style0 from "./DashboardAI.vue?vue&type=style&index=0&id=d6ec4a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ec4a02",
  null
  
)

export default component.exports